import React, {Component} from "react";
import {connect} from "react-redux";
import VideoPlayer from "./VideoPlayer.js";
import VideoBanner from "./VideoBanner.js";
import applogic from "../applogic.js";

class VideoPlayerWrapper extends Component {

    componentDidMount() {
        applogic.getVideoInfo(this.props.currentVideo);
    }

    render() {
        return (
            <div className="video-player-col container">
                <VideoBanner />
                <VideoPlayer />
            </div>
        );
    }
}
let mapStateToProps = (state) => {
    return {
        currentVideo: state.currentVideo,
    };
};
export default connect(mapStateToProps)(VideoPlayerWrapper);


// WEBPACK FOOTER //
// ./src/componentsBody/VideoPlayerWrapper.js